import script from "./ThreefoldIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreefoldIndicator.vue?vue&type=script&setup=true&lang=js"

import "./ThreefoldIndicator.vue?vue&type=style&index=0&id=0f906b6e&scoped=true&lang=scss"

import exportComponent from "C:\\repos\\1File_WebClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f906b6e"]])

export default __exports__